import React        from 'react';
import styled       from 'styled-components';
import TCell        from './components/TCell';
import { theme }    from 'theme';
import { apiTypes } from 'shared/consts/handbooksApiTypes';

interface IProps {
  config: any;
  row: any;
  isSelected?: boolean;
  onSelectRow?: (
    e: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    row: any
  ) => void;
  onRowChange?: (row: any, field: any, value: any) => void;
  onRowIndexChange?: (row: any, field: any, value: any) => void;
  errors?: { [field: string]: string };
  connections: {
    [key: string]: any[]
  }
  indexRow?: string;
  lastmodified?: any;
  styles?: any;
}

const SpreadRow = styled.tr<{ isSelected?: boolean }>`
  td {
    white-space: nowrap;
    border: 1px solid ${(props) => (props.isSelected ? theme.colors.themePrimary : '#ddd')};

    padding: 0;
    text-align: center;
    position: relative;
    height: 40px;
  }
`;

class TRow extends React.PureComponent<IProps>{
  render() {
    const { config, row, onSelectRow, isSelected, onRowChange, onRowIndexChange, errors, connections, styles } = this.props;

    return (
      <SpreadRow
        onClick={(e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) =>
          onSelectRow && onSelectRow(e, row)
        }
        isSelected={isSelected}
      >
        {((config || {}).fields || []).map((fl: any) => {
          if (fl.name === 'dow' && config.apiType !== apiTypes.DEFAULT) {
            const q = fl.innerColumns?.map((innerField: any, index: number) => {
              return <TCell
                        row={row}
                        key={`cell-${this.props.indexRow || ''}-${fl.name}-${index}`}
                        field={fl}
                        disabled={!row['__newEmpty'] && fl.disabled}
                        value={row[fl.name]?.split('')?.includes(innerField.key.toString())}
                        config={config}
                        errorMsg={errors && errors[fl.name] || undefined}
                        onValueChange={(field: any, value: any) =>
                          onRowChange && onRowChange(row, field, innerField.key)
                        }
                        onIndexChange = {(field: any, value: any) =>
                          onRowIndexChange && onRowIndexChange(row, field, value)
                        }
                        connection={fl.connection && connections ? { config: config.connections[fl.connection], list: connections[fl.connection] || [] } : undefined}
                      />
            })

            return q;
          }
           else if (!fl.hide) {
            return <TCell
                row={row}
                key={`cell-${this.props.indexRow || ''}-${fl.name}`}
                field={fl}
                disabled={!row['__newEmpty'] && fl.disabled}
                value={row[fl.name]}
                config={config}
                errorMsg={errors && errors[fl.name] || undefined}
                onValueChange={(field: any, value: any) =>
                  onRowChange && onRowChange(row, field, value)
                }
                onIndexChange = {(field: any, value: any) =>
                  onRowIndexChange && onRowIndexChange(row, field, value)
                }
                connection={fl.connection && connections ? { config: config.connections[fl.connection], list: connections[fl.connection] || [] } : undefined}
              />
          }
        })}
      </SpreadRow>
    );
  }
};

export default TRow;
